<div class="sidenav" [class.sidenav--collapsed]="isCollapsed" [class.sidenav--mobile-open]="mobileOpen">
    <!-- Collapse toggle button (desktop only) -->
    <button
        class="sidenav__collapse-btn"
        (click)="toggleCollapse()"
        [attr.aria-label]="isCollapsed ? 'Expand menu' : 'Collapse menu'"
    >
        <i [ngClass]="isCollapsed ? 'dr-icon-next-arrow' : 'dr-icon-back-arrow'"></i>
    </button>

    <nav class="sidenav__items">
        <!-- Section title -->
        <div class="section-title">{{ sectionTitle }}</div>

        <!-- Nav items -->
        <ng-container *ngFor="let item of navItems; last as isLast">
            <!-- Group item (has children) -->
            <ng-container *ngIf="item.children?.length; else singleItem">
                <div
                    class="nav-item nav-item--rounded"
                    [class.nav-item--last]="isLast"
                    [class.nav-item--expanded]="item.expanded"
                >
                    <!-- Group header -->
                    <a
                        class="nav-item__link"
                        [class.nav-item__link--active]="!item.expanded && hasActiveChild(item)"
                        (click)="toggleGroup(item, $event)"
                    >
                        <i class="nav-item__link__icon" [ngClass]="item.icon"></i>
                        <span class="nav-item__link__text" [ngClass]="item.textClass">{{ item.name }}</span>
                        <i
                            class="nav-item__link__collapse-icon"
                            [ngClass]="item.expanded ? 'dr-icon-arrow-up' : 'dr-icon-arrow-down'"
                        ></i>
                    </a>

                    <!-- Children -->
                    <div class="nav-item__children" *ngIf="item.expanded">
                        <div *ngFor="let child of item.children" class="nav-item nav-item--rounded nav-item--child">
                            <a
                                class="nav-item__link"
                                [routerLink]="child.route"
                                routerLinkActive="nav-item__link--active"
                                #childRla="routerLinkActive"
                                (click)="closeMobileNav()"
                            >
                                <i class="nav-item__link__icon" [ngClass]="getIconClass(child, childRla.isActive)"></i>
                                <span class="nav-item__link__text">{{ child.name }}</span>
                                <dr-badge-new *ngIf="child.badge" size="small" type="status" theme="beta">{{
                                    child.badge
                                }}</dr-badge-new>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Single item (no children) -->
            <ng-template #singleItem>
                <div class="nav-item nav-item--rounded" [class.nav-item--last]="isLast">
                    <a
                        class="nav-item__link"
                        [routerLink]="item.route"
                        routerLinkActive="nav-item__link--active"
                        #rla="routerLinkActive"
                        (click)="closeMobileNav()"
                    >
                        <i class="nav-item__link__icon" [ngClass]="getIconClass(item, rla.isActive)"></i>
                        <span class="nav-item__link__text" [ngClass]="item.textClass">{{ item.name }}</span>
                        <i *ngIf="item.locked" class="dr-icon-lock-close nav-item__link__lock"></i>
                    </a>
                </div>
            </ng-template>
        </ng-container>
    </nav>

    <div class="sidenav__footer" *ngIf="showEditSetupFooter">
        <div class="nav-item nav-item--rounded">
            <a class="nav-item__link" (click)="navigateToEditSetup()">
                <i class="nav-item__link__icon dr-icon-settings"></i>
                <span class="nav-item__link__text">Edit setup</span>
            </a>
        </div>
    </div>
</div>
